// extracted by mini-css-extract-plugin
export default {"brandLink":"styles_brandLink__qNwig","hasLink":"styles_hasLink__b-a1m","float":"styles_float__hfG35"};